import { Period } from '@enmon/commons/lib/enmon';
import dayjs, { type Dayjs } from 'dayjs';

/**
 * @returns Period range corresponding to provided Period and timeWindowShift relevant to provided dateTo(when not provided current date is used).
 */
export const getPeriodFromPredefined = (
  period: Period,
  timeWindowShift = 0,
  providedDateTo?: Dayjs,
): { dateFrom: Dayjs; dateTo: Dayjs } => {
  let dateTo = dayjs(providedDateTo);
  let dateFrom: Dayjs;

  switch (period) {
    case Period.Last24hours:
      dateFrom = dateTo
        .subtract(23, 'hours')
        .add(timeWindowShift * 24, 'hour')
        .startOf('hour');
      dateTo = dateTo.add(timeWindowShift * 24, 'hour');

      if (timeWindowShift !== 0) {
        dateTo = dateTo.endOf('hour');
      }
      break;
    case Period.Last7days:
      dateFrom = dateTo
        .subtract(6, 'days')
        .add(timeWindowShift * 7, 'day')
        .startOf('day');
      dateTo = dateTo.add(timeWindowShift * 7, 'day');

      if (timeWindowShift !== 0) {
        dateTo = dateTo.endOf('day');
      }
      break;
    case Period.Last30days:
      dateFrom = dateTo
        .subtract(29, 'days')
        .add(timeWindowShift * 30, 'day')
        .startOf('day');
      dateTo = dateTo.add(timeWindowShift * 30, 'day');

      if (timeWindowShift !== 0) {
        dateTo = dateTo.endOf('day');
      }
      break;
    case Period.Last3months:
      dateFrom = dateTo
        .subtract(2, 'months')
        .add(timeWindowShift * 3, 'month')
        .startOf('month');
      dateTo = dateTo.add(timeWindowShift * 3, 'month');

      if (timeWindowShift !== 0) {
        dateTo = dateTo.endOf('month');
      }
      break;
    case Period.Last12months:
      dateFrom = dateTo
        .subtract(11, 'months')
        .add(timeWindowShift * 12, 'month')
        .startOf('month');
      dateTo = dateTo.add(timeWindowShift * 12, 'month');

      if (timeWindowShift !== 0) {
        dateTo = dateTo.endOf('month');
      }
      break;
    case Period.Last24months:
      dateFrom = dateTo
        .subtract(23, 'months')
        .add(timeWindowShift * 24, 'month')
        .startOf('month');
      dateTo = dateTo.add(timeWindowShift * 24, 'month');

      if (timeWindowShift !== 0) {
        dateTo = dateTo.endOf('month');
      }
      break;
    case Period.Last36months:
      dateFrom = dateTo
        .subtract(35, 'months')
        .add(timeWindowShift * 36, 'month')
        .startOf('month');
      dateTo = dateTo.add(timeWindowShift * 36, 'month');
      if (timeWindowShift !== 0) {
        dateTo = dateTo.endOf('month');
      }
      break;
    case Period.ThisMonth:
      dateFrom = dateTo.add(timeWindowShift, 'month').startOf('month');
      dateTo = dateFrom.clone().endOf('month');
      break;
    case Period.ThisYear:
      dateFrom = dateTo.add(timeWindowShift * 12, 'month').startOf('year');
      dateTo = dateFrom.clone().endOf('year');
      break;
    case Period.PreviousMonth:
      dateFrom = dateTo.subtract(1, 'months').add(timeWindowShift, 'month').startOf('month');
      dateTo = dateFrom.clone().endOf('month');
      break;
    default:
      throw new Error(`Period ${period} is not supported as predefined in DateRangePicker.`);
  }

  return { dateFrom, dateTo };
};
